import styled from 'styled-components';
import { textTransform } from 'utils';

export const BirthdayRoomWrapper = styled.div.attrs({
  className: 'birthday-room'
})`
  width: 100%;
  max-width: 1238px;
  margin: 0 auto;
  padding: 0 16px;

  .birthday-room__title {
    display: inline-block;
    vertical-align: middle;
    font-size: 2.4rem;
    font-weight: 700;
    letter-spacing: 1px;
    text-transform: ${textTransform};
    color: ${({ theme }) => theme.color.textPrimary};
    margin: 24px 0 16px 0;
  }

  :after,
  :before {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  a {
    color: #DE1619;
    text-decoration: underline;
  }

  a:hover {
    cursor: pointer;
    outline: 0;
    // text-decoration: underline;
    color: #de1619;
  }
`;

export const BirthdayRoomContent = styled.div.attrs({
  className: 'birthday-room'
})`
  // text-align: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  .birthday-room__container {
    max-width: 872px;

    ul {
      & > li {
        list-style: circle;
        display: list-item;

        display: flex;
        align-items: flex-start;
        margin-top: 8px;

        // &:first-child {
        //   margin-top: 0;
        // }

        &:before {
          content: '';
          flex-shrink: 0;
          width: 24px;
          height: 24px;
          padding: 5px;
          margin-right: 8px;
          background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 78.369 78.369'%3E%3Cpath fill='%23de1619' d='M78.049 19.015L29.458 67.606a1.094 1.094 0 0 1-1.548 0L.32 40.015a1.094 1.094 0 0 1 0-1.547l6.704-6.704a1.095 1.095 0 0 1 1.548 0l20.113 20.112 41.113-41.113a1.095 1.095 0 0 1 1.548 0l6.703 6.704a1.094 1.094 0 0 1 0 1.548z'/%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-origin: content-box;
        }
      }
    }

    .birthday-room__title-wrapper {
      margin-top: 25px;
      h2 {
        font-weight: 450;
        font-size: 20px;
        line-height: 34px;
        letter-spacing: 1.5px;
        text-transform: ${textTransform};
      }

      .birthday-room__title-description {
        margin-top: 22px;
      }
    }

    .birthday-room__image-wrapper {
      margin-top: 25px;
      text-align: center;

      img {
        width: 628px;
        height: 353px;
      }

      h3 {
        font-style: italic;
        font-weight: 390;
        font-size: 16px;
        line-height: 24px;
        margint-top: 9px;
      }
    }

    .birthday-room__description2 {
      margin-top: 25px;
      // white-space: pre-line;
    }

    .birthday-room__description3-wrapper {
      margin-top: 50px;
      h2 {
        font-weight: 450;
        font-size: 20px;
        line-height: 34px;
        letter-spacing: 1.5px;
        text-transform: ${textTransform};
      }

      .birthday-room__description3 {
        margin: 24px 0 30px;
        // white-space: pre-line;
      }
    }
  }
`;

export default BirthdayRoomWrapper;
